const firebaseConfig = {
    apiKey: "AIzaSyA1mMtmxkMfaVuC9YuJ56vIrKoheKSltFQ",
    authDomain: "tourx-live.firebaseapp.com",
    projectId: "tourx-live",
    storageBucket: "tourx-live.appspot.com",
    messagingSenderId: "217209422320",
    appId: "1:217209422320:web:2ebc1963a014bebe8b5d35"
};

export default firebaseConfig;